<div class="comment-thread flex h-full min-h-0 flex-col bg-white">
  <div *ngIf="showHeader" class="flex flex-shrink-0 items-start justify-between border-b border-gray-200 px-4 py-3">
    <div class="min-w-0 pr-3">
      <h3 class="truncate text-lg font-semibold text-gray-900">{{ title || 'Comments' }}</h3>
      <p class="mt-0.5 text-sm text-gray-600">
        {{ sortedComments.length }}
        comment{{ sortedComments.length === 1 ? '' : 's' }}
      </p>
    </div>
    <button
      type="button"
      (click)="close.emit($event)"
      class="rounded-md p-2 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
      aria-label="Close comments">
      <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.75" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  </div>

  <div *ngIf="!showHeader" class="flex flex-shrink-0 items-baseline justify-between px-1 pb-3 pt-1">
    <h3 class="text-base font-semibold text-gray-900">Comments</h3>
    <span class="text-sm text-gray-600">{{ sortedComments.length }}</span>
  </div>

  <div
    #threadScroll
    (scroll)="onThreadScroll()"
    class="thread-scroll min-h-0 flex-1 overflow-y-auto px-1">
    <div *ngIf="loading" class="flex items-center justify-center py-10 text-sm text-gray-600">
      <div class="mr-2 h-5 w-5 animate-spin rounded-full border-2 border-gray-200 border-b-gray-700"></div>
      Loading comments...
    </div>

    <div *ngIf="!loading && sortedComments.length === 0" class="flex h-full min-h-[8rem] items-center justify-center px-4 text-center text-sm text-gray-600">
      No comments yet. Start the thread below.
    </div>

    <ul *ngIf="!loading && sortedComments.length > 0" class="space-y-4 py-1 pb-3" role="list">
      <li *ngFor="let comment of sortedComments; trackBy: trackByComment" class="flex items-start gap-3">
        <div class="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-gray-200 text-sm font-medium text-gray-700">
          {{ userInitial(comment) }}
        </div>
        <div class="min-w-0 flex-1">
          <div class="flex flex-wrap items-baseline gap-x-2 gap-y-0.5">
            <span class="text-sm font-medium text-gray-900">{{ userName(comment) }}</span>
            <span class="text-xs text-gray-600">{{ formatDate(comment.timestamp) }}</span>
          </div>
          <p class="mt-1 whitespace-pre-wrap break-words text-sm leading-5 text-gray-800">{{ comment.content }}</p>
        </div>
      </li>
    </ul>
  </div>

  <div class="flex-shrink-0 border-t border-gray-200 bg-white pt-3">
    <form (ngSubmit)="onSend()" class="flex items-end gap-2">
      <label class="sr-only" [attr.for]="composerId">Comment</label>
      <textarea
        [id]="composerId"
        [name]="composerId"
        rows="2"
        [ngModel]="draft"
        (ngModelChange)="onDraftInput($event)"
        (keydown)="onComposerKeydown($event)"
        [disabled]="disabled || loading"
        placeholder="Write a comment..."
        class="block max-h-32 min-h-[2.75rem] w-full resize-none rounded-lg border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 caret-indigo-600 placeholder:text-gray-500 focus:border-indigo-500 focus:ring-indigo-500 disabled:bg-gray-50 disabled:text-gray-500"></textarea>
      <button
        type="submit"
        [disabled]="!canSend"
        class="inline-flex h-11 flex-shrink-0 items-center justify-center rounded-lg bg-gray-900 px-3 text-sm font-semibold text-white transition-[transform,background-color] duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] hover:bg-gray-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2 active:scale-[0.97] disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-500 disabled:active:scale-100"
        aria-label="Send comment">
        <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.75" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
        </svg>
      </button>
    </form>
    <p class="mt-1.5 text-xs text-gray-500">Ctrl or ⌘ + Enter to send</p>
  </div>
</div>
